// extracted by mini-css-extract-plugin
export default {"container":"PrivacyAware__container___kDy36","screenContainer":"PrivacyAware__screenContainer___mkUkC"};